import React from 'react';
import { Briefcase, Check } from 'lucide-react';

import './Experience.css';
import { theme } from '../../theme/designSystem';
import { experienceData } from '../../data/experienceData';

function Experience() {
    return (
        <section className="experience section-pad" id="experience" style={{ backgroundColor: theme.secondary }}>
            <div className="experience--container">
                <div className="experience--header">
                    <span className="eyebrow">Career</span>
                    <h2 style={{ color: theme.primary }}>A decade building at the hard edge</h2>
                    <p style={{ color: theme.textSecondary }}>
                        From core engineer on acquired telematics platforms to Director of Technology.
                    </p>
                </div>

                <div className="experience--timeline">
                    {experienceData.map((exp, index) => (
                        <div
                            key={exp.id}
                            className="experience--card fade-in-up"
                            style={{
                                backgroundColor: theme.cardBg,
                                borderColor: theme.border,
                                animationDelay: `${index * 0.08}s`
                            }}
                        >
                            <div className="experience--icon" style={{ backgroundColor: theme.accent }}>
                                <Briefcase size={18} color="#FFF" />
                            </div>
                            <div className="experience--content">
                                <span className="experience--dates" style={{ color: theme.accent }}>
                                    {exp.startYear} to {exp.endYear}
                                </span>
                                <h3 style={{ color: theme.primary }}>{exp.jobtitle}</h3>
                                <p className="experience--company" style={{ color: theme.textSecondary }}>
                                    {exp.company} · {exp.location}
                                </p>
                                {exp.description && (
                                    <p className="experience--desc" style={{ color: theme.textSecondary }}>
                                        {exp.description}
                                    </p>
                                )}
                                {exp.highlights && exp.highlights.length > 0 && (
                                    <ul className="experience--highlights">
                                        {exp.highlights.map((h, i) => (
                                            <li key={i} style={{ color: theme.textSecondary }}>
                                                <Check size={15} style={{ color: theme.accent }} />
                                                <span>{h}</span>
                                            </li>
                                        ))}
                                    </ul>
                                )}
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}

export default Experience;
